(function () {
  'use strict';

  angular.module('app').component('documentTypeList', documentTypeList());

  function documentTypeList() {
    return {
      bindings: {
        documentTypes: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowDocumentType: '&',
      },
      controller: DocumentTypeListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/document-types/document-type-list/document-type-list.component.html',
    };
  }

  DocumentTypeListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'ModalWindowConfirmService',
    'SessionService',
    '$location',
    'DocumentTypeService',
  ];

  function DocumentTypeListComponent(
    config,
    UtilService,
    AbilityService,
    ModalWindowConfirmService,
    SessionService,
    $location,
    DocumentTypeService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_documenttype_accountadmin'),
      canUpdate: AbilityService.can('update_documenttype_accountadmin'),
      canDestroy: AbilityService.can('destroy_documenttype_accountadmin'),
      canListIntegrations: true, // pending
    };

    vm.filterCriteria = DocumentTypeService.getFilterCriteria();
    vm.transactionTypes = config.TRANSACTION_TYPES;

    vm.showAllItems = false;

    // private properties
    // -----------------------
    const atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled;

    vm.$onInit = function () {
      // Initializers
      // checkDefaultDocumentTypes(vm.documentTypes);

      vm.documentTypesOriginal = [...vm.documentTypes];

      vm.filterByStatus();
    };

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      // vm.filterCriteria.lang = $translate.use();

      vm.loadingItems = true;
      DocumentTypeService.getDocumentTypes(vm.filterCriteria).then((data) => {
        // vm.documentTypes  = DocumentTypeService.groupDocumentTypesByTransactionType(documentTypes);

        vm.documentTypes = data.items;
        vm.meta = data.meta;

        vm.documentTypesOriginal = [...vm.documentTypes];

        vm.totalItems = vm.meta.totalItems;

        // checkDefaultDocumentTypes(vm.documentTypes);

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;

        vm.filterByStatus();
      });
    };

    // refresh the data with the default filter criteria
    vm.refresh = function () {
      vm.filterCriteria = DocumentTypeService.getFilterCriteria();
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      vm.fetchResult();
    };

    vm.showDocumentType = function (documentType, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowDocumentType({ item: documentType, mode: mode });
    };

    vm.changeDocumentTypeStatus = function (documentType) {
      // Cannot update status if is default or if is default && inactive
      let changeDocumentTypeStatusCallback = () => {
        if (
          vm.permissions.canUpdate &&
          (!documentType.is_default ||
            (documentType.is_default && documentType.status === 'inactive'))
        ) {
          DocumentTypeService.changeDocumentTypeStatus(documentType);
        }
      };

      let successCallback = () => {
        $location.path('/integrations');
      };

      if (!atvCrEnabled && documentType.numbering_type === 'electronic') {
        // ATV desactivado (null or false) y el tipo documento es electrónico
        // Los documentos electrónicos solo se pueden activar cuando la configuración de ATV está configurada correctamente
        let modalParams = {
          mode: 'warning',
          title: 'ELECTRONIC_DOCUMENTS_BY_ATV',
          confirmButtonLabel: 'SET_ATV_CONFIGURATION',
          body: '',
        };

        ModalWindowConfirmService.open(modalParams, successCallback);
      } else {
        changeDocumentTypeStatusCallback();
      }
    };

    vm.changeDocumentTypeDefault = function (documentType) {
      if (
        !vm.permissions.canUpdate ||
        documentType.is_default ||
        documentType.status === 'inactive'
      ) {
        return;
      }

      DocumentTypeService.changeDocumentTypeDefault(documentType, vm.fetchResult);
    };

    vm.deleteDocumentType = function (documentType) {
      // Cannot delete if predefined or is default
      //if (!vm.permissions.canDestroy || documentType.is_predefined || documentType.is_default ){ return; }

      if (vm.permissions.canDestroy && !documentType.predefined && !documentType.is_default) {
        DocumentTypeService.deleteDocumentType(documentType, vm.fetchResult);
      }
    };

    vm.filterByStatus = function () {
      if (vm.showAllItems) {
        vm.documentTypes = vm.documentTypesOriginal;
      } else {
        vm.documentTypes = vm.documentTypesOriginal.filter((x) => x.status === 'active');
      }
    };
  }
})();
